function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2345 4629 c-394 -41 -792 -208 -1103 -461 -534 -437 -820 -1126 -752 -1809 100 -990 879 -1769 1869 -1869 445 -44 913 65 1298 303 668 414 1051 1190 973 1968 -100 991 -878 1769 -1869 1869 -118 11 -299 11 -416 -1z m311 -1304 c66 -50 65 -38 62 -620 -3 -511 -3 -524 -24 -551 -32 -44 -68 -66 -116 -71 -58 -7 -108 15 -144 63 l-29 37 -3 511 c-2 281 0 525 3 543 7 40 49 91 90 109 46 22 117 12 161 -21z m-16 -1587 c57 -39 75 -72 75 -138 0 -63 -16 -95 -69 -134 -39 -29 -133 -29 -173 0 -54 40 -75 83 -71 142 8 89 73 152 158 152 32 0 57 -7 80 -22z"
}));
function SvgInaccuracy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInaccuracy);
export default __webpack_public_path__ + "static/media/inaccuracy.b22d5dd3a508cd5abe8b2d30ab24d76d.svg";
export { ForwardRef as ReactComponent };